import { isFirefoxError } from '../typeguards/isFirefoxError';
import { isSafariError } from '../typeguards/isSafariError';
import { Payload } from '../../types/payload';

const transformError = (error: Error) => {
  const transformed: Record<string, unknown> = {};

  if (isFirefoxError(error)) {
    transformed.fileName = error.fileName;
    transformed.lineNumber = error.lineNumber;
    transformed.columnNumber = error.columnNumber;
  }

  if (isSafariError(error)) {
    transformed.fileName = error.sourceURL;
    transformed.lineNumber = error.line;
    transformed.columnNumber = error.column;
  }

  transformed.type ||= error.name;
  transformed.message ||= error.message;
  transformed.stack ||= error.stack;

  return { ...transformed, ...error };
};

const transformUnknownObject = (payloadObject: object | null) => {
  const transformed: Record<string, unknown> = {};

  Object.entries(payloadObject ?? {}).forEach(([key, value]) => {
    transformed[key] = value;

    if (value instanceof Error) {
      transformed[key] = transformError(value);

      // Copying error fields to the top level of the log.
      // We want every log to include an 'mdc.payload_message'
      // field (not to be confused with 'message') for Dashboard construction.
      Object.assign(transformed, transformed[key]);
    }
  });

  return transformed;
};

export const transformErrorToObject = (payload: Payload): Record<string, unknown> => {
  if (payload instanceof Error) {
    return transformError(payload);
  }

  if (typeof payload === 'object') {
    return transformUnknownObject(payload);
  }

  return { message: payload };
};
